<pay-login-topbar class="absolute right-16 top-8" />
<div class="grid h-full grid-cols-1 xl:grid-cols-2">
  <div class="hidden flex-col items-center gap-4 bg-secondary-5 xl:flex xl:px-5 2xl:px-20">
    <div class="flex w-[80%] grow flex-col pb-5 sm:pt-20">
      <div class="flex min-w-full flex-grow flex-col justify-self-start">
        <pay-login-news-list [newsItems]="newsItems()" />
      </div>
      <div class="justify-self-end bg-secondary-5 py-2">
        <span class="text-md font-heading">
          {{ 'status.api-status' | translate }}
        </span>
        <div>
          <pay-login-server-status [incidents]="activeIncidents()" payLibSkeletonLoader heightClass="min-h-20" [skeletonCondition]="loadingIncidents()" />
        </div>
      </div>
      <div class="relative gap-3 justify-self-end pt-3">
        @if (plannedIncident(); as incident) {
          <span class="text-md w-full pt-4 font-heading">
            {{ 'status.scheduled-maintenance' | translate }}
          </span>
          <div class="pt-4">
            <pay-login-incident-entry class="w-full" [incident]="incident" />
          </div>
        }
      </div>
    </div>
  </div>
  <div class="flex h-full flex-col">
    <div class="flex h-full flex-col justify-center">
      <div class="flex flex-col items-center justify-center gap-4 overflow-clip">
        <div class="relative w-16 flex-1 overflow-hidden md:w-24">
          <pay-login-logo [width]="90" [height]="60" />
        </div>
        <span class="hidden overflow-hidden font-heading text-xl font-medium xs:text-xl sm:block sm:text-2xl lg:text-3xl">
          {{ _headerText() | translate }}
        </span>
        <div class="w-full max-w-[505px] px-6">
          <router-outlet />
        </div>
      </div>
    </div>
    @if (newsItems().length === 0) {
      <div class="flex w-full justify-center justify-self-end pb-10">
        <div class="w-full max-w-[460px] justify-self-end">
          <pay-login-server-status [incidents]="activeIncidents()" payLibSkeletonLoader heightClass="min-h-20" [skeletonCondition]="loadingIncidents()" />
        </div>
      </div>
    }
  </div>
</div>
